import { createContext, useContext } from "react";
import { useParams } from 'react-router-dom';
import { useFetcher } from "../../hooks/Fetcher";
import { api } from "../../utils/api";

const JobContext = createContext({});

export function useJobContext() {
  return useContext(JobContext);
}

export default function JobPageLoader({ children }) {
  const { job_id } = useParams();

  const { data, error, isLoading } = useFetcher([job_id], async () => {
    const { data } = await api.get(`/job_postings/${job_id}`, {
      validateStatus: (status) => status === 200
    });

    return data;
  });
  
  if (isLoading) {
    return (
      <p>Loading...</p>
    );
  }

  if (!data || error) {
    return (
      <p>Something went wrong.</p>
    );
  }

  return (
    <JobContext.Provider value={ { job: data } }>
      { children }
    </JobContext.Provider>
  );
}
